import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsGearFill, BsCheckCircle, BsFileEarmarkText, BsClipboardData } from 'react-icons/bs';

interface AcoesAdminModalProps {
  show: boolean;
  processo: any;
  onClose: () => void;
  onAssociarConta: () => void;
  onIntegracaoSiga: () => void;
  onStatusCandidatos: () => void;
}

const AcoesAdminModal: React.FC<AcoesAdminModalProps> = ({
  show,
  processo,
  onClose,
  onAssociarConta,
  onIntegracaoSiga,
  onStatusCandidatos
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ações Administrativas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Button
            variant="outline-primary"
            onClick={() => {
              onAssociarConta();
              onClose();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '12px',
              padding: '12px 16px',
              fontSize: '14px'
            }}
          >
            <BsGearFill size={20} />
            <span>Associar Conta de Serviço</span>
          </Button>

          <Button
            variant={processo.hasIntegracaoSiga ? 'outline-success' : 'outline-secondary'}
            onClick={() => {
              onIntegracaoSiga();
              onClose();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '12px',
              padding: '12px 16px',
              fontSize: '14px'
            }}
          >
            {processo.hasIntegracaoSiga ? <BsCheckCircle size={20} /> : <BsFileEarmarkText size={20} />}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <span>Integração SIGA (Vestibular)</span>
              <small style={{ fontSize: '11px', opacity: 0.7 }}>
                {processo.hasIntegracaoSiga ? 'Ativa' : 'Inativa'}
              </small>
            </div>
          </Button>

          <Button
            variant="outline-info"
            onClick={() => {
              onStatusCandidatos();
              onClose();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '12px',
              padding: '12px 16px',
              fontSize: '14px'
            }}
          >
            <BsClipboardData size={20} />
            <span>Status de Candidatos por Edital</span>
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AcoesAdminModal;
